import { css } from '@emotion/css';
import { LoadingSpinner } from '@src/common/components/LoadingSpinner';
import { Stack } from '@src/common/components/Stack';

export const LoadingPage = () => {
  return (
    <Stack className={pageWrapper} justifyContent="center" alignItems="center">
      <LoadingSpinner />
    </Stack>
  );
};

const pageWrapper = css`
  width: 100%;
  height: 100vh;
`;
